import { render } from "./HomepageView.vue?vue&type=template&id=6ecdf64b&scoped=true"
import script from "./HomepageView.vue?vue&type=script&lang=js"
export * from "./HomepageView.vue?vue&type=script&lang=js"

import "./HomepageView.vue?vue&type=style&index=0&id=6ecdf64b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecdf64b"]])

export default __exports__